import axiosInstance from 'src/utils/axios';
import {
  ActivityCalculatorSettingsFull,
  GetActivityCalculatorSettingsFullResponse,
  GetActivityCalculatorSettingsResponse,
} from './types.api';

//
//

const BASE_URL = '/cms/v1/component-settings/activity-calculator';

//

export const getActivityCalculatorSettingsByMerchantCodeAPI = async (
  merchantCode: string
): Promise<GetActivityCalculatorSettingsResponse> => {
  const response = await axiosInstance.get<GetActivityCalculatorSettingsResponse>(`${BASE_URL}`, {
    params: { merchantCode },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const saveActivityCalculatorSettingsAPI = async (
  merchantCode: string,
  data: ActivityCalculatorSettingsFull
) => {
  const savedSettings = await axiosInstance.post(`${BASE_URL}`, JSON.stringify(data));
  const activityCalculatorId = savedSettings.data.id;
  await connectMerchantToActivityCalculatorAPI(merchantCode, activityCalculatorId);

  return savedSettings;
};

const connectMerchantToActivityCalculatorAPI = async (
  merchantCode: string,
  activityCalculatorId: string
) => {
  const response = await axiosInstance.post(
    `${BASE_URL}/${activityCalculatorId}/merchant/${merchantCode}`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const updateActivityCalculatorSettingsAPI = async (
  id: string,
  data: ActivityCalculatorSettingsFull
): Promise<GetActivityCalculatorSettingsFullResponse> => {
  const response = await axiosInstance.put<GetActivityCalculatorSettingsFullResponse>(
    `${BASE_URL}/${id}`,
    data
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getActivityCalculatorSettingsByIdAPI = async (
  id: string
): Promise<GetActivityCalculatorSettingsFullResponse> => {
  const response = await axiosInstance.get<GetActivityCalculatorSettingsFullResponse>(
    `${BASE_URL}/${id}`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};
